import AppSwitch from 'components/atoms/AppSwitch/AppSwitch'

interface Props {
    checked: boolean
    onChange: (value: boolean) => void
    disabled?: boolean
}

const ACCESSIBLE_NAME = 'Contenerización'

/** Toggle that marks an order as "sin contenerización" at creation time. */
const WithoutContainerizationSwitch = ({ checked, onChange, disabled }: Props) => (
    <div className="flex items-center gap-3">
        <AppSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            ariaLabel={ACCESSIBLE_NAME}
        />
        <span className="text-sm text-[#070A13]">
            {checked ? 'Activado' : 'Desactivado'}
        </span>
    </div>
)

export default WithoutContainerizationSwitch
